export default __webpack_public_path__ + "static/author-mushahid-khatri-db0bf10bd1cceaf9034c346b53cec7cd.jpg";